<div class="container-card">
  <div
    [ngStyle]="{ background: background, height: height }"
    class="card-component"
  >
    <div>
      <img class="img-card" [src]="'assets/img/icons/' + Items.img" alt="" />
      <span class="title">{{ Items.title }}</span>
      <span style="font-size: 14px;">{{Items.text}}</span>
    </div>
  </div>
</div>
